/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unused-vars */

import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import LandingInstantOfferTest from './index.js'

import './styles/index.scss'

export async function loader({context}: LoaderFunctionArgs) {
  const {domain, i18n} = context

  try {
    const {LANDING_INSTANT_OFFER_TEST_PATTERN} = domain.get('config').get('page')
    const {pageName} = await domain
      .get('get_page_name_page_use_case')
      .execute({path: LANDING_INSTANT_OFFER_TEST_PATTERN})

    const [, getSeoDataResponse] = await domain.get('get_seo_data_use_case').execute({
      culture: i18n.culture,
      pageName
    })

    return {
      pageName,
      helmet: getSeoDataResponse?.head || {}
    }
  } catch (error: unknown) {
    console.error('[RR7] LandingInstantOfferTest loader error:', error)
    return {
      pageName: '',
      helmet: {}
    }
  }
}

export function Component() {
  const data = useLoaderData()
  return <LandingInstantOfferTest {...data} />
}

Component.displayName = 'LandingInstantOfferTestRoute'
